export let Application = {
    path: 'application',
    name: 'application',
    component: () => import(/*  */ '@/views/back-stage/application/app-page.vue'),
};

export let AppMenegement = {
    path: 'appmenegement',
    name: 'app-menegement',
    component: () =>
        import(/* webpackChunkName: "app-menegement" */ '@/views/back-stage/application/app-menegement.vue'),
    children: [
        {
            path: 'basic',
            name: 'basic',
            component: () =>
                import(/* webpackChunkName: "basic-menegement" */ '@/views/back-stage/application/basic-menegement.vue'),
        },
        {
            path: 'rights',
            name: 'rights',
            component: () =>
                import(/* webpackChunkName: "rights-menegement" */ '@/views/back-stage/application/rights-menegement.vue'),
        },
        {
            path: 'rightspreview',
            name: 'rightspreview',
            component: () =>
                import(/* webpackChunkName: "rights-preview-menegement" */ '@/views/back-stage/application/rights-preview.vue'),
        },
        {
            path: 'link-app-design',
            name: 'link-app-design',
            component: () =>
                import(/* webpackChunkName: "link-app-design" */ '@/views/back-stage/application/link-app-design.vue'),
        },
        {
            path: '*',
            redirect: 'basic',
        },
    ],
};

export let Application2 = {
    path: 'application2',
    name: 'application2',
    component: () => import(/*  */ '@/views/back-stage/application2/app-page.vue'),
    children: [
        {
            path: 'app-all',
            name: 'app-all',
            component: () =>
                import(/* webpackChunkName: "app-all" */ '@/views/back-stage/application2/app-all.vue'),
        },
        {
            path: 'app-my',
            name: 'app-my',
            component: () =>
                import(/* webpackChunkName: "app-my" */ '@/views/back-stage/application2/app-my.vue'),
        },
        {
            path: 'app-disabled',
            name: 'app-disabled',
            component: () =>
                import(/* webpackChunkName: "app-disabled" */ '@/views/back-stage/application2/app-disabled.vue'),
        },
        {
            path: '*',
            redirect: 'app-all',
        },
    ],
};
